export const LOCAL_STORAGE_SIGNUP_BANNER_SHOWN = '@wemolo/signup/banner'

export const LOCAL_STORAGE_setSignupBannerShown = (shown = true) => {
    localStorage.setItem(LOCAL_STORAGE_SIGNUP_BANNER_SHOWN, JSON.stringify(shown))
}

export const LOCAL_STORAGE_getSignupBannerShown = (): boolean => {
    const shown = localStorage.getItem(LOCAL_STORAGE_SIGNUP_BANNER_SHOWN)
    return shown ? JSON.parse(shown) : false
}

export const LOCAL_STORAGE_removeSignupBannerShown = () => {
    localStorage.removeItem(LOCAL_STORAGE_SIGNUP_BANNER_SHOWN)
}
